import {Component, OnInit, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';



import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-report-configurator-view',
  templateUrl: './report-configurator-view.component.html',
  styleUrls: ['./report-configurator-view.component.css']
})
export class ReportConfiguratorViewComponent implements OnInit {

  dataLoaded: boolean;
  private notifier: NotifierService;
  angularGrid: AngularGridInstance;
  gridObj: any;
  respObject: any;
  private clientId: number;
  templateArray = [];
  templateSelected: number;
  tableView: boolean;
  graphView: boolean;

  reportTableObj = [];

  gridOptions: GridOption;
  columnDefinitions: Column[];

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
    private modalService: NgbModal, notifier: NotifierService) {
      this.notifier = notifier;
  }

  ngOnInit() {
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
       
        //this.userGroups = this.respObject.details[0].groupId;
       
        //this.userGroupId = this.userGroups[0].groupId;
        //this.userGroupSelected = this.userGroupId;
        //this.onPageLoad();

        this.tableView = false;
        this.graphView = false;
        this.getTemplateList();
        
        
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    console.log('grid initiate');
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
  }

  initTableView(){
    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: false,
      enableRowSelection: true,
      enableHeaderMenu: false,
      enableGridMenu : true,
    };
    
  }

  getTemplateList(){
    this.dataLoaded = false;
    this._rest.getReportConfiguratorTemplateList(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.dataLoaded = true;
            const dataArr = this.respObject.details;
            // console.log('master data=', dataArr);
            this.templateArray = dataArr;
            this.templateArray.unshift({id: 0, template_name: 'Select Template'});
            this.templateSelected = 0;
            // this.totalData = dataArr.length;
        } else {
          this.dataLoaded = true;
          this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
      this.dataLoaded = true;
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  onTemplateChange(value: any){
    // console.log(this.templateArray[value].template_name);
    // console.log(this.templateSelected);
    this.dataLoaded = false;
    this._rest.getReportTableData(this.clientId, this.templateSelected).subscribe((res1) => {
        this.respObject = res1;
        // console.log(this.respObject);
        const columnDefinitions = [];
        if (this.respObject.success) {
            this.dataLoaded = true;
            const detailsObj = this.respObject.details[0];
            if(detailsObj.type === 'table'){
              this.tableView = true;
              
              detailsObj.columns.forEach((column, i) => {
                columnDefinitions.push({id: column.column_name, name: column.report_field_name, field: column.column_name, sortable: false, filterable: false});
              });
             this.columnDefinitions = columnDefinitions;
             this.initTableView();
             this.reportTableObj = detailsObj.val;
            }
            
        } else {
            this.dataLoaded = true;
            this.notifier.notify('error', this.respObject.errorMessage);
            this.columnDefinitions = columnDefinitions;
        }
    }, (err) => {
        this.dataLoaded = true;
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

}
